/** Header logo + favicon (mms-ui Logo-M.png in static) */
export const LOGO_MARK_PATH = '/assets/img/logo/Logo-M.png';
